import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class RouteStorageService {
  constructor(private location: Location) {}

  saveRoute(route: string) {
    const cleanedRoute = route.split('?')[0];
    if (!cleanedRoute.includes('/briefcase') || cleanedRoute === '/briefcase') {
      return;
    }
    if (cleanedRoute) {
      localStorage.setItem('scRoute', cleanedRoute);
    }
  }

  loadRoute(): string | null {
    const route = localStorage.getItem('scRoute');
    if (route && (!route.includes('/briefcase') || route === '/briefcase')) {
      localStorage.removeItem('scRoute');
      return null;
    }
    return route;
  }

  // This will update the url and store the saved route in case of reload/logout
  // We do this manually here so the page doesn't do an unnecessary reload which causes duplicate queries
  setCurrentRoute(url: string) {
    this.location.replaceState(url);
    this.saveRoute(url);
  }
}
